import { withTheme } from '@emotion/react';
import { Check, CircleOutlined } from '@mui/icons-material';
import { Alert, Avatar, Box, Button, CardHeader, Collapse, Switch } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import React, { Component } from 'react';
import { Trans } from 'react-i18next';
import BrainoSnackbar from '../commons/BrainoSnackbar';
import I18n, { getFlag } from '../commons/Utils';
import i18n from '../commons/i18n';
import DialogHelp from '../elements/DialogHelp';
import api from '../services/api';

class SettingsMain extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      helpOpen: false,
      detailsOpen: false,
      helpTitle: '',
      helpText: '',
      helpTitle: <Trans> {this.props.prefix} </Trans>,
      helpText: <I18n prefix={this.props.prefix} type="help"></I18n>,
      lang: localStorage.getItem('LANG'),
      notify1: false,
      notify2: false,
      isLight: true,
      open: false,

      snackOpen: false,
      snackMessage: ''
    }
  }

  closeDetailsDialog() {
    this.setState({ detailsOpen: false })
  }

  openDetailsDialog() {
    this.setState({ detailsOpen: true })
  }

  async componentDidMount() {
    this.loadNotifications1()
    this.loadNotifications2()

    
    api.get('profiles/' + localStorage.getItem('ID'))
      .then(response => {
        const data = response.data
        this.setState({ data });
      }).catch(error => {
        console.log(error);
      })
  }

  async changeLangServer(value) {
    
    api.put('lang/' + localStorage.getItem('ID'), 'lang=' + value)
      .then(response => {
        localStorage.setItem('LANG', value);
        this.setState({ snackOpen: true, snackMessage: 'Language changed' })
      }).catch(error => {
        console.log(error);
      })
  }

  closeHelpDialog() {
    this.setState({ helpOpen: false })
  }

  openHelpDialog() {
    this.setState({ helpOpen: true })
  }

  changeLang(value) {
    if (value !== i18n.language) {
      i18n.changeLanguage(value)
      i18n.reloadResources();
      this.setState({ lang: value })
      this.changeLangServer(value)
    }
  }

  loadNotifications1() {
    
    api.get('social/newsletter_accept/' + localStorage.getItem('ID'))
      .then(response => {
        const data = response.data
        let accept = data === "1" ? 1 : 0
        this.setState({ notify1: accept, open: accept ? false : true })
      }).catch(error => {
        console.log(error);
      })
  }

  loadNotifications2() {
    
    api.get('social/newsletter2_accept/' + localStorage.getItem('ID'))
      .then(response => {
        const data = response.data
        let accept = data === "1" ? 1 : 0
        this.setState({ notify2: accept })
      }).catch(error => {
        console.log(error);
      })
  }

  changeNotifications1(e) {
    let value = e.target.checked
    value = value ? 1 : 0
    this.setState({ notify1: value })
    
    api.put('social/newsletter_accept/' + localStorage.getItem('ID') + '/' + value, null)
      .then(response => {
        this.setState({ open: !value })
      }).catch(error => {
        console.log(error);
      })
  }

  changeNotifications2(value) {
    value = value ? 1 : 0
    this.setState({ notify2: value })
    
    api.put('social/newsletter2_accept/' + localStorage.getItem('ID') + '/' + value, null)
      .then(response => {

      }).catch(error => {
        console.log(error);
      })
  }

  render() {
    const { lang, notify1, notify2, isLight, snackOpen, snackMessage, open } = this.state;
    return (
      <Card variant="outlined">
        <DialogHelp
          closeHelpDialog={() => this.closeHelpDialog()}
          isHelpDialogOpen={this.state.helpOpen}
          helpDialogTitle={this.state.helpTitle}
          helpDialogContent={this.state.helpText}
          okButton="ok" />

        <BrainoSnackbar
          open={snackOpen}
          onClose={() => { this.setState({ snackOpen: false }) }}
          message={snackMessage}
        />

        <CardHeader
          title={<Typography gutterBottom variant="overline" component="h2">{t("settings_pageTitle")}</Typography>}
        ></CardHeader>
        <CardContent>
          <Box sx={{ p: 2 }}>
            <Box><Typography gutterBottom variant='subtitle2'><Trans>lang_checkboxTitle</Trans></Typography></Box>
            <Box sx={{ mb: 3 }}>
              <Button size='small' disableElevation startIcon={<Avatar variant='square' sx={{ width: 22, height: 18 }} src={getFlag("Italy")} />} sx={{ mr: 1 }} variant={lang === 'it' ? 'contained' : 'outlined'} onClick={() => this.changeLang('it')}>Italiano</Button>
              <Button size='small' disableElevation startIcon={<Avatar variant='square' sx={{ width: 22, height: 18 }} src={getFlag("UnitedKingdom")} />} sx={{ mr: 1 }} variant={lang === 'en' ? 'contained' : 'outlined'} onClick={() => this.changeLang('en')}>English</Button>
            </Box>
            {/* <Typography gutterBottom variant='subtitle2'><Trans>notifications_checkboxTitle</Trans></Typography>
            <Box sx={{ display: 'flex', mb: 3, flexDirection: 'column' }}>
              <Box sx={{ display: 'flex' }}>
                <Box sx={{ flex: '70%' }}>{t("mail_marketing_checkboxTitle")}</Box>
                <Box sx={{ flex: '30%' }}> <Switch checked={notify1} onChange={(e) => this.changeNotifications1(e)} inputProps={{ 'aria-label': 'controlled' }} /></Box>
              </Box>
              <Collapse timeout={150} in={open}>
                <Alert severity="warning" color='error' sx={{ pb: 2 }}>
                  <Trans>reg_alert_msg</Trans>
                </Alert>
              </Collapse>
            </Box>
            <Box sx={{ display: 'flex', mb: 3 }}>
              <Box sx={{ flex: '70%' }}>{t("mail_preferences_checkboxTitle")}</Box>
              <Box sx={{ flex: '30%' }}> <Switch checked={notify2} onChange={(e) => this.changeNotifications2(e.target.checked)} /></Box>
            </Box> */}
          </Box>
        </CardContent>
      </Card>
    );
  }
}

export default withTheme(SettingsMain);
